// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"bf069101","68":"8b8dcd90","191":"a6087d7a","227":"26ffa53a","289":"2b5c4886"}[chunkId] + ".chunk.js";
};